import { Component, inject, OnDestroy, OnInit, ViewChild,ElementRef } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HomeService } from '../home.service';
import { decodeBase64ToText, encodeToBase64, formatDate } from '../../utility';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../api.service';
import { Subscription } from 'rxjs';
import { PageMetadataService } from '../../shared/services/page-metadata.service';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../shared/services/http.service';
import { HelperService } from '../../shared/services/helper.service';
import { SidebarService } from '../../shared/services/sidebar.service';

interface Theme {
  key: string;
  value: string
}


@Component({
  selector: 'app-outcome-modal',
  templateUrl: './outcome-modal.component.html',
  styleUrl: './outcome-modal.component.css',
})
export class OutcomeModalComponent implements OnInit, OnDestroy {
  outcomesListUrl:string= '';
  helper=inject(HelperService)
  httpService=inject(HttpService)
  sidebarService=inject(SidebarService)
  themes: Theme[] = [];
  quarter: any[];
  outcomesList: any[] = [];
  page: number= 0;
  prevPage: number = 0;
  limit = 10;
  loading = false;
  title:any;
  currentQuater:any;
  currentTheme:any;
  category: string;
  currentYear:any

  private roleSubscription: Subscription;
  private quaterSubscription: Subscription;
  private themeSubscription: Subscription;
  private homeService = inject(HomeService);
  private apiService= inject(ApiService);
  outcomeYear: { key: number; value: number; }[];
  businessThemeLists: any=[];
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private pageMetadataService: PageMetadataService
  ) {
    this.title = config.data.title;
    this.businessThemeLists = config.data.businessThemeLists;
    this.quarter = config.data.quarter;
    // this.currentTheme = config.data.currentTheme;
    this.pageMetadataService.setTitle('Outcomes | OBP')
  }


  listPayloadData: any = {
    "outcome_type":"quarterly", // optional , "quarterly","annual"
  }

  ngOnInit(): void {    
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.category = data;
      //this.themeList(data);
      //this.quarterList(data);
      //this.getOutcomesList(data);
    });
    this.outcomesListUrl = `${environment.opbBackendHost}/api/${this.category}/dashboard/list`;
    this.outcomeYear = this.helper.generateYearArray(2022);
    this.listPayloadData.outcome_quarters=this.sidebarService.selectedHomeQuarter
    if(this.sidebarService.selectedHomeYear?.value){
      this.currentYear=this.sidebarService.selectedHomeYear?.value
    }else{
      this.currentYear=new Date().getFullYear()
    }
    this.listPayloadData.outcome_year=this.currentYear
    if(this.sidebarService.selectedHomeQuarter){
      this.currentQuater=this.sidebarService.selectedHomeQuarter
    }else{
      this.quaterSubscription = this.apiService.quarter$.subscribe((data) => {
        this.currentQuater=data;
      });
    }
    this.currentTheme=this.sidebarService.selectedHomeThemeId
    if(this.sidebarService.selectedHomeYear?.value){
      this.getGuarterListByYear(this.category,this.sidebarService.selectedHomeYear.value)
      this.fetchThemeListBasedOnYear(this.sidebarService.selectedHomeYear.value)
    }else{
      this.getGuarterListByYear(this.category,this.currentYear)
      this.fetchThemeListBasedOnYear(this.currentYear)
    }
    
    this.getOutcomesList(this.category,this.listPayloadData)
    // this.themeSubscription = this.apiService.theme$.subscribe((data) => {
    //   this.currentTheme=data;
    //   this.getOutcomesList(this.category);
    // });
    
    // this.listPayloadData.outcome_quarters=this.sidebarService.homeData.outcome_quarters;
    // this.fetchThemeListBasedOnYear(this.sidebarService.homeData?.outcome_year)
    // this.setDefaultTheme();
    // this.currentTheme=this.sidebarService.selectedHomeThemeId
  }


  onHomeYearChange(event:any){
    this.currentTheme=null
    this.listPayloadData.outcome_year=event?.value?.value || event?.value
    this.listPayloadData.outcome_themes=null
    this.getOutcomesList(this.category,this.listPayloadData);
    this.getGuarterListByYear(this.category,event?.value?.value || event?.value);
    this.fetchThemeListBasedOnYear(event?.value?.value || event?.value)
  }

  fetchThemeListBasedOnYear(year:any){
    this.helper.fetchThemeListBasedOnYear(year).subscribe((res: any) => {
      this.businessThemeLists = res?.data;
    });
  }

  getGuarterListByYear(cat:any,year:any,){
    this.helper.fetchquarterListBasedOnYear(cat,year).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      })
  }

  onDataLoaded(data: any[]) {
    this.outcomesList = data;
  }


  setDefaultTheme() {
    const defaultTheme = this.themes.find((theme: Theme) => theme.key === this.currentTheme);
  
    if (!defaultTheme) {
      this.currentTheme = this.currentTheme;
    }
  }

  // themeList(cat: string) {
    
  //   this.homeService.getthemeList({}, cat).subscribe(
  //     (data: any) => {
       
  //         try {
  //           const parsedData = data;
  //           this.themes = parsedData.data || []; 
  //         } catch (error) {
  //           console.error('Error parsing decoded data:', error);
  //         }
  //     },
  //     (error) => {
  //       console.error('Error fetching users', error);
  //     }
  //   );
  // }
  quarterList(cat: string) {
    const data = {
      "year":this.currentYear
    };
    this.homeService.getQuarterList(data, cat).subscribe(
      (data: any) => {
       
          try {
            const parsedData = data;
            this.quarter = parsedData.data || []; 
            this.quarterFields(this.quarter);
          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }


  getOutcomesList(cat: string,data?:any) {
    if (this.loading) return;
    this.loading = true;
    let status = "1,2,3,4,5";
    if (this.title == "Not Started") {
      status = "1";
    } else if (this.title == "Ongoing") {
      status = "2";
    } else if (this.title == "Completed") {
      status = "3";
    } else if (this.title == "Delayed") {
      status = "4";
    } else if (this.title == "Terminated") {
      status = "5";
    }
  
    // Payload setup
    this.listPayloadData.outcome_status = status;
    // this.listPayloadData.outcome_type = "quarterly";
    // this.listPayloadData.page = this.page;
    // if (this.listPayloadData.outcome_themes) {
      //this.listPayloadData.outcome_themes;
    // }
    // if (this.currentQuater!=null) {
    //   this.listPayloadData.outcome_quarters=this.sidebarService.selectedHomeQuarter;
    // }
    // if (this.currentTheme!=="" && this.currentTheme!==null) {
    //   this.listPayloadData.outcome_themes=this.sidebarService.homeData.outcome_themes;
    // }
  // if(this.currentYear != null){
  //   this.listPayloadData.outcome_year=this.sidebarService.homeData.outcome_year;

  // }
    this.homeService.getOutcomesList({...this.listPayloadData}, cat).subscribe(
      (data: any) => {
  
        try {
          const parsedData = data;

          if (parsedData.data && Array.isArray(parsedData.data)) {
           
            this.outcomesList= [...parsedData.data];
            
            this.loading = false;
          } 
        } catch (error) {
          console.error('Error parsing decoded data:', error);
          this.loading = false; // Handle error gracefully and stop loading
        }
      },
      (error) => {
        console.error('Error fetching outcomes list:', error);
        this.loading = false; // Handle error gracefully and stop loading
      }
    );
  }
  

  quarterFields(timelines: any[]) {
    timelines.forEach((timeline) => {
      timeline.quarterVal = `Cycle ${timeline.quarter}`;
    });
  }

  onThemeFilterChange(event:any) {
    this.listPayloadData.outcome_themes = event?.value;
    this.getOutcomesList(this.category,this.listPayloadData)
  }

  onQuarterFilterChange(data:any) {
    this.listPayloadData.outcome_quarters= String(data)
    this.getOutcomesList(this.category,this.listPayloadData);
  }

  onScroll(event: any): void {
    if(this.prevPage===this.page){
      this.roleSubscription = this.apiService.role$.subscribe((data) => {
          this.getOutcomesList(data);
      });
    }
  }
  
  
  ngOnDestroy() {
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe(); // Clean up subscription when component is destroyed
    }

    if(this.quaterSubscription){
      this.quaterSubscription.unsubscribe();
    }

    if(this.themeSubscription){
      this.themeSubscription.unsubscribe();
    }
  }
}
